import { getRoleLabelByKey, getRoleToneByKey } from './roles.utils';

type InvitationGroupChip = {
  role: string;
  label: string;
  className: string;
};

export function getInvitationGroupLabel(role: string): string {
  return getRoleLabelByKey(role);
}

export function getInvitationGroupChipClass(role: string): string {
  return getRoleToneByKey(role).pillClassName;
}

export function getInvitationGroupChips(
  invitationGroups: string[] | null
): InvitationGroupChip[] {
  if (!invitationGroups || invitationGroups.length === 0) {
    return [];
  }

  return invitationGroups.map((role) => ({
    role,
    label: getInvitationGroupLabel(role),
    className: getInvitationGroupChipClass(role),
  }));
}
